export * from './removeEndingIn';
